import * as firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
import MockLessons from 'mocks/MockLessons';
import Lesson from 'models/Lesson';

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyD4nR6knf6fiKfR6QMYI2osQPF2_aj-adM',
  authDomain: 'curriculum-db.firebaseapp.com',
  databaseURL: 'https://curriculum-db.firebaseio.com/',
  storageBucket: 'curriculum-db.appspot.com',
};

export const LESSONS_DOCUMENT = '/lessons';

const MockDatabase = {
  ref: () => ({
    once: () =>
      Promise.resolve({
        val: (): Lesson[] => MockLessons,
      }),
    push: (_: any, callback: (error?: any) => void) => {
      callback();
      return { key: 'mockkey' };
    },
    set: (data: any) => {
      console.log('Saving data', data);
      return Promise.resolve();
    },
    remove: () => Promise.resolve(),
  }),
};

const MockAuth = {
  signInWithPopup: () =>
    Promise.resolve({
      credential: null,
      user: null,
    }),
  signOut: () => Promise.resolve(),
};

enum Mode {
  Dev = 'development',
  Prod = 'production',
}

class Database {
  private mode: Mode = Mode.Prod;

  constructor() {
    if (process.env.REACT_APP_DATA_SOURCE === 'mock') {
      this.mode = Mode.Dev;
      console.log('Currently running in development mode.');
    } else {
      firebase.initializeApp(FIREBASE_CONFIG);
    }
  }

  get() {
    if (this.mode === Mode.Dev) {
      return MockDatabase;
    }
    return firebase.database();
  }

  async saveFile(file: any, recordKey: string) {
    if (this.mode === Mode.Dev) {
      console.log('File uploaded');
      return Promise.resolve();
    }

    const fileStorageRef = firebase.storage().ref(LESSONS_DOCUMENT);
    const uploadFileTask = fileStorageRef.child(recordKey).put(file);

    const addDownloadUrlToLessonRecord = async () => {
      const fileDownloadUrl = await uploadFileTask.snapshot.ref.getDownloadURL();
      const updates = { lessonFileId: fileDownloadUrl };

      firebase.database().ref(LESSONS_DOCUMENT).child(recordKey).update(updates);
    };

    uploadFileTask.on(
      'state_changed',
      // TODO: incorporate into spinner on form or perhaps a progress indicator
      (snapshot) => {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
      },

      (error) => console.log(error),

      addDownloadUrlToLessonRecord,
    );
  }

  auth() {
    if (this.mode === Mode.Dev) {
      return MockAuth;
    }
    return firebase.auth();
  }
}

export default new Database();
